(() => {
  'use strict';
  // The dedicated Napoleon sections retain their existing metaobject-rendered data.
  if (window.cmNapoleonGalleryInitialized || typeof HTMLDialogElement === 'undefined') return;
  const colorSelector = '[data-cm-napoleon-gallery="colors"]';
  const detailSelector = '[data-cm-napoleon-gallery="details"]';
  const colors = () => Array.from(document.querySelectorAll(colorSelector)).flatMap(root => {
    const items = Array.from(root.querySelectorAll('[data-cm-cv-item]'));
    if (root.dataset.cmNpgGeneric !== 'colors') return items;
    // Preserve the generic reader's visual order without changing dedicated series.
    return items.map((card, domIndex) => {
      const parsed = Number.parseFloat(card.dataset.sortOrder || '');
      return {card, domIndex, sortOrder:Number.isFinite(parsed) ? parsed : 9999};
    }).sort((left, right) => left.sortOrder - right.sortOrder || left.domIndex - right.domIndex)
      .map(entry => entry.card);
  });
  const cards = () => Array.from(document.querySelectorAll(`${detailSelector} [data-cm-pd-card]`)).filter(card => card.dataset.modalSrc?.trim());
  if (!colors().length && !cards().length) return;
  window.cmNapoleonGalleryInitialized = true;
  const dialog = document.createElement('dialog');
  dialog.className = 'cm-npg-dialog';
  dialog.setAttribute('aria-labelledby', 'cm-npg-heading');
  dialog.innerHTML = `<div class="cm-npg-layout"><div class="cm-npg-header"><div><p class="cm-npg-eyebrow">COCOMEISTER / PRODUCT GALLERY</p><h2 id="cm-npg-heading"></h2></div><button class="cm-npg-button" data-close type="button" aria-label="閉じる" autofocus>×</button></div><div class="cm-npg-stage"><div class="cm-npg-viewport"><img alt="" draggable="false"><p class="cm-npg-error" role="status" hidden>画像を読み込めませんでした。次の写真をご覧ください。</p></div><button class="cm-npg-zoom" data-zoom type="button" aria-label="画像を2倍に拡大" aria-pressed="false" aria-describedby="cm-npg-zoom-help" disabled><span data-zoom-symbol aria-hidden="true">＋</span><span data-zoom-label>拡大</span></button><span class="cm-npg-zoom-help" id="cm-npg-zoom-help">写真のクリック・タップでも拡大できます。拡大後はドラッグで移動し、2本指で拡大率を調整できます。</span></div><div class="cm-npg-copy"><p class="cm-npg-number"></p><h3></h3><p class="cm-npg-caption"></p></div><nav class="cm-npg-details" aria-label="表示するディテール" hidden></nav><div class="cm-npg-footer"><button class="cm-npg-button" data-prev type="button" aria-label="前の写真">←</button><span class="cm-npg-counter" aria-live="polite"></span><button class="cm-npg-button" data-next type="button" aria-label="次の写真">→</button></div><nav class="cm-npg-colors" aria-label="表示するカラー" hidden></nav></div>`;
  document.body.append(dialog);
  const q = selector => dialog.querySelector(selector);
  let image = q('.cm-npg-viewport img');
  const stage = q('.cm-npg-stage'), viewport = q('.cm-npg-viewport'), zoomButton = q('[data-zoom]');
  stage.append(q('.cm-npg-counter'));
  const zoom = {scale:1, x:0, y:0, ready:false};
  const pointers = new Map();
  let gesture = null, gestureMoved = false, suppressPhotoClickUntil = 0;
  const clamp = (value, min, max) => Math.max(min, Math.min(value, max));
  const panLimit = (imageSize, viewportSize, scale) => Math.max(0, (imageSize * scale - viewportSize) / 2);
  const anchoredOffset = (point, offset, oldScale, newScale) => point - (point - offset) * newScale / oldScale;
  const mobileDetailQuery = window.matchMedia('(max-width: 749px)');
  let controlsGeometry = '';
  function renderZoom() {
    const limitX = panLimit(image.offsetWidth, viewport.clientWidth, zoom.scale);
    const limitY = panLimit(image.offsetHeight, viewport.clientHeight, zoom.scale);
    zoom.x = clamp(zoom.x, -limitX, limitX);
    zoom.y = clamp(zoom.y, -limitY, limitY);
    image.style.transform = `translate3d(${zoom.x}px,${zoom.y}px,0) scale(${zoom.scale})`;
    // Anchor arrows to the fitted photo in both modes, independent of zoom/pan.
    const ratio = (Number(image.getAttribute('width')) || 1) / (Number(image.getAttribute('height')) || 1);
    const width = image.offsetWidth || Math.min(viewport.clientWidth, viewport.clientHeight * ratio);
    const height = image.offsetHeight || width / ratio;
    const insetX = Math.max(0, (viewport.clientWidth - width) / 2);
    const insetY = Math.max(0, (viewport.clientHeight - height) / 2);
    const geometry = [insetX, insetY, stage.offsetTop + insetY,
      stage.offsetLeft + insetX + width, stage.offsetTop + insetY + height,
      stage.offsetLeft + viewport.clientWidth / 2, stage.offsetLeft + insetX];
    const key = geometry.join(',');
    if (key !== controlsGeometry) {
      controlsGeometry = key;
      ['inset-x', 'inset-y', 'top', 'right', 'bottom', 'center-x', 'left'].forEach((name, index) => {
        dialog.style.setProperty(`--cm-npg-photo-${name}`, `${geometry[index]}px`);
      });
    }
    zoomButton.style.right = `${insetX + 12}px`;
    zoomButton.style.bottom = `${insetY + 12}px`;
    stage.classList.toggle('cm-npg-stage--narrow', width < 260);
    const enlarged = zoom.scale > 1.001;
    stage.classList.toggle('cm-npg-stage--ready', zoom.ready);
    stage.classList.toggle('cm-npg-stage--zoomed', enlarged);
    zoomButton.disabled = !zoom.ready;
    zoomButton.setAttribute('aria-pressed', String(enlarged));
    zoomButton.setAttribute('aria-label', enlarged ? '画像を全体表示に戻す' : '画像を2倍に拡大');
    zoomButton.title = enlarged ? '全体表示に戻す / 拡大中はドラッグで移動' : '画像を2倍に拡大';
    q('[data-zoom-symbol]').textContent = enlarged ? '−' : '＋';
    q('[data-zoom-label]').textContent = enlarged ? '縮小' : '拡大';
  }
  function resetZoom() {
    pointers.forEach((_, id) => { if (viewport.hasPointerCapture(id)) viewport.releasePointerCapture(id); });
    pointers.clear(); gesture = null; gestureMoved = false;
    zoom.scale = 1; zoom.x = zoom.y = 0;
    stage.classList.remove('cm-npg-stage--dragging');
    renderZoom();
  }
  function toggleZoom(clientX, clientY) {
    if (!zoom.ready) return;
    const rect = viewport.getBoundingClientRect();
    const nextScale = zoom.scale > 1.001 ? 1 : 2;
    const pointX = Number.isFinite(clientX) ? clientX - rect.left - rect.width / 2 : 0;
    const pointY = Number.isFinite(clientY) ? clientY - rect.top - rect.height / 2 : 0;
    zoom.x = anchoredOffset(pointX, zoom.x, zoom.scale, nextScale);
    zoom.y = anchoredOffset(pointY, zoom.y, zoom.scale, nextScale);
    zoom.scale = nextScale;
    renderZoom();
  }
  function beginGesture() {
    const points = Array.from(pointers.values());
    if (points.length > 1) {
      const [a, b] = points, rect = viewport.getBoundingClientRect();
      const centerX = (a.x + b.x) / 2 - rect.left - rect.width / 2;
      const centerY = (a.y + b.y) / 2 - rect.top - rect.height / 2;
      gesture = {kind:'pinch', distance:Math.max(1, Math.hypot(a.x - b.x, a.y - b.y)), scale:zoom.scale,
        anchorX:(centerX - zoom.x) / zoom.scale, anchorY:(centerY - zoom.y) / zoom.scale};
      gestureMoved = true;
    } else if (points.length) {
      const swipeEligible = zoom.scale <= 1.001 && !gestureMoved;
      gesture = {kind:swipeEligible ? 'pending' : 'pan', startX:points[0].x, startY:points[0].y, x:zoom.x, y:zoom.y, started:performance.now()};
    } else gesture = null;
    stage.classList.toggle('cm-npg-stage--dragging', pointers.size > 0 && zoom.scale > 1.001);
  }
  zoomButton.addEventListener('click', () => toggleZoom());
  viewport.addEventListener('pointerdown', event => {
    const canSwipe = zoom.scale <= 1.001;
    if ((!zoom.ready && !canSwipe) || event.button !== 0 || (!pointers.size && !canSwipe && event.target !== image)) return;
    // Keep vertical touch scrolling and ordinary mouse clicks until horizontal intent is clear.
    if (!canSwipe) event.preventDefault();
    if (!pointers.size) gestureMoved = false;
    pointers.set(event.pointerId, {x:event.clientX, y:event.clientY, type:event.pointerType});
    viewport.setPointerCapture(event.pointerId);
    beginGesture();
  });
  viewport.addEventListener('pointermove', event => {
    if (!pointers.has(event.pointerId) || !gesture) return;
    pointers.set(event.pointerId, {x:event.clientX, y:event.clientY, type:event.pointerType});
    if (gesture.kind === 'pending' || gesture.kind === 'swipe' || gesture.kind === 'scroll') {
      const dx = event.clientX - gesture.startX, dy = event.clientY - gesture.startY;
      if (Math.hypot(dx, dy) > 6) gestureMoved = true;
      if (gesture.kind === 'pending' && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) {
        if (Math.abs(dx) > Math.abs(dy) * 1.3) gesture.kind = 'swipe';
        else if (Math.abs(dy) >= Math.abs(dx)) gesture.kind = 'scroll';
      }
      if (gesture.kind === 'swipe') event.preventDefault();
      return;
    }
    event.preventDefault();
    if (gesture.kind === 'pinch') {
      const [a, b] = Array.from(pointers.values()), rect = viewport.getBoundingClientRect();
      zoom.scale = clamp(gesture.scale * Math.hypot(a.x - b.x, a.y - b.y) / gesture.distance, 1, 3);
      zoom.x = (a.x + b.x) / 2 - rect.left - rect.width / 2 - gesture.anchorX * zoom.scale;
      zoom.y = (a.y + b.y) / 2 - rect.top - rect.height / 2 - gesture.anchorY * zoom.scale;
    } else {
      const dx = event.clientX - gesture.startX, dy = event.clientY - gesture.startY;
      if (Math.hypot(dx, dy) > 6) gestureMoved = true;
      zoom.x = gesture.x + dx; zoom.y = gesture.y + dy;
    }
    renderZoom();
    stage.classList.toggle('cm-npg-stage--dragging', zoom.scale > 1.001);
  });
  function finishPointer(event, cancelled = false) {
    if (!pointers.has(event.pointerId)) return;
    const lastPointer = pointers.size === 1, endedGesture = gesture;
    const dx = event.clientX - (endedGesture?.startX ?? event.clientX);
    const dy = event.clientY - (endedGesture?.startY ?? event.clientY);
    const tapped = !cancelled && lastPointer && ['pan', 'pending'].includes(endedGesture?.kind)
      && !gestureMoved && Math.hypot(dx, dy) <= 6;
    const swiped = !cancelled && lastPointer && endedGesture?.kind === 'swipe'
      && Math.abs(dx) >= Math.max(42, viewport.clientWidth * 0.12)
      && Math.abs(dx) > Math.abs(dy) * 1.3;
    if (gestureMoved || cancelled) suppressPhotoClickUntil = performance.now() + 450;
    pointers.delete(event.pointerId);
    if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
    beginGesture();
    if (swiped && slides.length > 1) move(dx < 0 ? 1 : -1);
    else if (tapped) toggleZoom(event.clientX, event.clientY);
  }
  viewport.addEventListener('click', event => {
    if (performance.now() < suppressPhotoClickUntil) { event.preventDefault(); event.stopPropagation(); }
  }, true);
  viewport.addEventListener('pointerup', event => finishPointer(event));
  viewport.addEventListener('pointercancel', event => finishPointer(event, true));
  viewport.addEventListener('lostpointercapture', event => finishPointer(event, true));
  if (typeof ResizeObserver !== 'undefined') new ResizeObserver(renderZoom).observe(viewport);
  let slides = [], index = 0, trigger = null, timer, loadVersion = 0, colorMode = false;
  let scrollLock = null;
  function lockPage() {
    if (scrollLock) return;
    const root = document.documentElement, body = document.body;
    scrollLock = {x:window.scrollX, y:window.scrollY, rootOverflow:root.style.overflow,
      bodyStyles:Object.fromEntries(['position','top','left','right','width','overflow'].map(key => [key, body.style[key]]))};
    root.style.overflow = 'hidden';
    Object.assign(body.style, {position:'fixed', top:`${-scrollLock.y}px`, left:`${-scrollLock.x}px`, right:'0', width:'100%', overflow:'hidden'});
  }
  function unlockPage() {
    if (!scrollLock) return;
    const saved = scrollLock;
    scrollLock = null;
    document.documentElement.style.overflow = saved.rootOverflow;
    Object.assign(document.body.style, saved.bodyStyles);
    const behavior = document.documentElement.style.scrollBehavior;
    document.documentElement.style.scrollBehavior = 'auto';
    window.scrollTo(saved.x, saved.y);
    document.documentElement.style.scrollBehavior = behavior;
  }
  const text = (node, selector) => node.querySelector(selector)?.textContent.trim() || '';
  const detailSlides = () => cards().map(card => ({
    src:card.dataset.modalSrc, width:card.dataset.modalWidth, height:card.dataset.modalHeight,
    title:card.dataset.modalTitle?.trim() || '製品説明',
    alt:card.querySelector('img')?.alt || `${card.dataset.modalTitle || '製品説明'} ${card.dataset.modalIndex || ''}`,
    copy:card.dataset.modalDescription || text(card, '.cm-product-detail__body')
  }));
  function revealInStrip(strip, selected) {
    if (!selected || strip.scrollWidth <= strip.clientWidth) return;
    const stripRect = strip.getBoundingClientRect(), selectedRect = selected.getBoundingClientRect();
    if (selectedRect.left < stripRect.left) strip.scrollLeft -= stripRect.left - selectedRect.left + 3;
    else if (selectedRect.right > stripRect.right) strip.scrollLeft += selectedRect.right - stripRect.right + 3;
  }
  function colorGallery() {
    const groups = colors().map((card, colorIndex) => {
      const gallery = card.querySelector('template[data-cm-cv-gallery]');
      const name = card.dataset.modalTitle || text(card,'.cm-color-variations__item-title');
      const copy = text(card,'.cm-color-variations__description');
      const thumbnail = card.querySelector('img');
      const nodes = gallery ? Array.from(gallery.content.querySelectorAll('[data-cm-cv-gallery-image]')) : [];
      const photos = nodes.filter(node => node.dataset.src?.trim()).map(node => ({
        src:node.dataset.src, width:node.dataset.width, height:node.dataset.height,
        alt:node.dataset.alt || name, title:name, copy
      }));
      if (!photos.length && card.dataset.modalSrc?.trim()) photos.push({
        src:card.dataset.modalSrc, width:thumbnail?.width, height:thumbnail?.height,
        alt:name, title:name, copy
      });
      return {card, colorIndex, name, thumbnail:thumbnail?.currentSrc || thumbnail?.getAttribute('src') || '', photos};
    }).filter(group => group.photos.length);
    let firstIndex = 0;
    groups.forEach((group, colorPosition) => {
      group.firstIndex = firstIndex;
      group.photos.forEach((photo, photoIndex) => Object.assign(photo, {
        colorIndex:group.colorIndex, colorPosition, colorCount:groups.length,
        photoIndex, photoCount:group.photos.length
      }));
      firstIndex += group.photos.length;
    });
    return groups;
  }
  function paint() {
    const slide = slides[index];
    if (!slide) return;
    zoom.ready = false;
    resetZoom();
    q('h3').textContent = slide.title;
    q('h3').hidden = !colorMode;
    q('.cm-npg-caption').textContent = slide.copy;
    q('.cm-npg-number').textContent = colorMode
      ? `COLOR ${String(slide.colorPosition + 1).padStart(2,'0')}`
      : String(index + 1).padStart(2,'0');
    q('.cm-npg-counter').textContent = colorMode
      ? `${slide.photoIndex + 1} / ${slide.photoCount}`
      : `${index + 1} / ${slides.length}`;
    q('.cm-npg-colors').querySelectorAll('button').forEach(button => {
      button.setAttribute('aria-pressed', String(Number(button.dataset.colorIndex) === slide.colorIndex));
    });
    if (colorMode) requestAnimationFrame(() => {
      if (dialog.open && colorMode) revealInStrip(q('.cm-npg-colors'), q('.cm-npg-colors [aria-pressed="true"]'));
    });
    const detailNav = q('.cm-npg-details');
    detailNav.querySelectorAll('button').forEach((button, detailIndex) => {
      button.setAttribute('aria-pressed', String(detailIndex === index));
    });
    // Scroll only the thumbnail strip; never move the dialog or background page.
    if (!colorMode) requestAnimationFrame(() => {
      if (!dialog.open || colorMode) return;
      const selected = detailNav.querySelector('[aria-pressed="true"]');
      revealInStrip(detailNav, selected);
    });
    const hasCopy = Boolean(slide.copy || (slide.title && slide.title !== '製品説明'));
    dialog.classList.toggle('cm-npg-dialog--photo-only', !hasCopy);
    q('.cm-npg-copy').hidden = !hasCopy;
    q('.cm-npg-copy').scrollTop = 0;
    q('[data-prev]').disabled = q('[data-next]').disabled = slides.length < 2;
    // A fresh node gives each request its own handlers, even during rapid navigation.
    const nextImage = document.createElement('img');
    nextImage.draggable = false;
    image.replaceWith(nextImage);
    image = nextImage;
    image.alt = slide.alt;
    image.width = Number(slide.width) || 1;
    image.height = Number(slide.height) || 1;
    image.hidden = false;
    q('.cm-npg-error').hidden = true;
    clearTimeout(timer);
    const version = ++loadVersion;
    let settled = false;
    const fail = () => { if (version !== loadVersion || settled) return; settled = true; clearTimeout(timer); zoom.ready = false; resetZoom(); image.hidden = true; q('.cm-npg-error').hidden = false; };
    image.onerror = fail;
    image.onload = () => { if (version !== loadVersion || settled) return; if (!image.naturalWidth) return fail(); settled = true; clearTimeout(timer); zoom.ready = true; renderZoom(); };
    image.src = slide.src;
    timer = setTimeout(fail, 15000);
  }
  function open(nextSlides, firstIndex, title, opener, groups = []) {
    if (!nextSlides.length) return;
    colorMode = groups.length > 0;
    dialog.classList.toggle('cm-npg-dialog--colors', colorMode);
    dialog.classList.toggle('cm-npg-dialog--details', !colorMode);
    const detailNav = q('.cm-npg-details');
    detailNav.replaceChildren();
    detailNav.hidden = colorMode;
    if (!colorMode) nextSlides.forEach((slide, detailIndex) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cm-npg-detail';
      button.setAttribute('aria-label', `ディテール${detailIndex + 1}の写真を表示`);
      button.setAttribute('aria-pressed', 'false');
      const thumbnail = document.createElement('img');
      const thumbnailUrl = new URL(slide.src, location.href);
      if (thumbnailUrl.hostname.endsWith('cocomeister.jp') || thumbnailUrl.hostname.endsWith('shopify.com')) thumbnailUrl.searchParams.set('width', '160');
      thumbnail.src = thumbnailUrl.href;
      thumbnail.alt = ''; thumbnail.decoding = 'async';
      const label = document.createElement('span');
      label.textContent = String(detailIndex + 1).padStart(2, '0');
      button.append(thumbnail, label);
      button.addEventListener('click', () => { index = detailIndex; paint(); });
      detailNav.append(button);
    });
    const selectors = q('.cm-npg-colors');
    selectors.replaceChildren();
    selectors.hidden = !colorMode;
    groups.forEach(group => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'cm-npg-color';
      button.dataset.colorIndex = group.colorIndex;
      button.setAttribute('aria-label', `${group.name}の写真を表示`);
      button.setAttribute('aria-pressed', 'false');
      if (group.thumbnail) {
        const thumbnail = document.createElement('img');
        thumbnail.src = group.thumbnail; thumbnail.alt = ''; thumbnail.loading = 'lazy';
        button.append(thumbnail);
      }
      const label = document.createElement('span');
      label.textContent = group.name;
      button.append(label);
      button.addEventListener('click', () => { index = group.firstIndex; paint(); });
      selectors.append(button);
    });
    slides = nextSlides; index = Math.max(0, Math.min(firstIndex, slides.length-1));
    q('#cm-npg-heading').textContent = title;
    if (!dialog.open) {
      trigger = opener || document.activeElement;
      lockPage();
      paint();
      try { dialog.showModal(); } catch { unlockPage(); return; }
    } else paint();
    q('[data-close]').focus({preventScroll:true});
  }
  function openColor(card, opener) {
    const groups = colorGallery();
    const selected = groups.find(group => group.card === card) || groups[0];
    if (!selected) return;
    open(groups.flatMap(group => group.photos),selected.firstIndex,'カラーバリエーション',opener,groups);
  }
  function openDetail(card, opener) { open(detailSlides(), Math.max(0,cards().indexOf(card)), '製品説明',opener); }
  function move(step) { index = (index + step + slides.length) % slides.length; paint(); }
  function preparePhotoTriggers() {
    document.querySelectorAll(`${detailSelector} .cm-product-detail__media > img`).forEach(photo => {
      photo.tabIndex = 0;
      photo.dataset.cmNpgOpenPhoto = '';
      photo.setAttribute('role', 'button');
      photo.setAttribute('aria-haspopup', 'dialog');
      photo.setAttribute('aria-label', `${photo.alt || '製品説明'}を拡大表示`);
    });
  }
  preparePhotoTriggers();
  document.addEventListener('shopify:section:load', preparePhotoTriggers);
  document.addEventListener('shopify:section:unload', event => {
    if (dialog.open && event.target instanceof Element && (event.target.matches('[data-cm-napoleon-gallery]') || event.target.querySelector('[data-cm-napoleon-gallery]'))) dialog.close();
  });
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const colorButton = event.target.closest(`${colorSelector} [data-cm-cv-open]`);
    if (colorButton) {
      event.preventDefault();
      openColor(colorButton.closest('[data-cm-cv-item]'), colorButton);
      return;
    }
    const detailRoot = event.target.closest(detailSelector);
    if (!detailRoot) return;
    const allButton = event.target.closest('[data-cm-pd-open-all]');
    if (allButton) { event.preventDefault(); openDetail(cards()[0], allButton); return; }
    const media = event.target.closest('.cm-product-detail__media');
    if (media) {
      event.preventDefault();
      openDetail(media.closest('[data-cm-pd-card]'), event.target.closest('button') || media.querySelector('[data-cm-npg-open-photo]'));
    }
  });
  document.addEventListener('keydown', event => {
    if (event.target instanceof Element && event.target.matches(`${detailSelector} [data-cm-npg-open-photo]`) && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      openDetail(event.target.closest('[data-cm-pd-card]'), event.target);
    }
  });
  q('[data-close]').addEventListener('click',()=>dialog.close());
  q('[data-prev]').addEventListener('click',()=>move(-1));
  q('[data-next]').addEventListener('click',()=>move(1));
  dialog.addEventListener('close',()=>{
    clearTimeout(timer); ++loadVersion;
    zoom.ready = false; resetZoom();
    unlockPage();
    if(trigger?.isConnected) trigger.focus({preventScroll:true});
  });
  dialog.addEventListener('click',event=>{if(event.target !== dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});
  dialog.addEventListener('keydown',event=>{
    if(!event.altKey&&!event.ctrlKey&&!event.metaKey&&['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowLeft'?-1:1);}
    if(event.key==='Tab'){
      const controls=Array.from(dialog.querySelectorAll('button:not(:disabled)')).filter(button => !button.closest('[hidden]') && button.getClientRects().length);
      const first=controls[0],last=controls.at(-1);
      if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
      else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
    }
  });
})();
